import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { shortDate } from "../../lib/format";
import { Sprout, ChevronRight, Calendar } from "lucide-react";

const pick = (lang, hi, en) => (lang === "English" ? en : hi);

const STAGE_HI = { Vegetative: "बढ़वार", Flowering: "फूल", "Pod-filling": "फली भरना", Maturity: "पकाई", Sowing: "बुवाई", Harvest: "कटाई" };
const barColor = (p) => (p >= 80 ? "#f2a30f" : p >= 45 ? "#2f9e3a" : "#5aa84f");

export function CropCycles({ cycles, language, item }) {
  const list = [...(cycles || [])].sort((a, b) => (b.progress || 0) - (a.progress || 0));
  return (
    <motion.div variants={item} className="agro-glass rounded-[22px] p-5" data-testid="crop-cycles-card">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-display font-bold text-[17px] text-[#173f1e] flex items-center gap-2"><Sprout className="h-5 w-5 text-[#2f9e3a]" />{pick(language, "फसल चक्र", "Crop Cycles")}</h2>
        <Link to="/crops" className="text-sm font-semibold text-[#2f7d33] flex items-center tap" data-testid="cycles-see-all">{pick(language, "सभी", "All")}<ChevronRight className="h-4 w-4" /></Link>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-[#6c7a67] py-4 text-center">{pick(language, "कोई सक्रिय फसल नहीं। नई फसल जोड़ें।", "No active crops. Add one to get started.")}</p>
      ) : (
        <div className="space-y-3">
          {list.slice(0, 5).map((c, i) => (
            <div key={`${c.id || "cyc"}-${i}`} className="rounded-2xl bg-white/60 p-3 border border-black/5" data-testid={`cycle-${i}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                  <p className="font-semibold text-sm text-[#1c2b1e] truncate">{c.cropName} <span className="text-[11px] text-[#9aa79a] font-normal">· {c.variety || "Local"}</span></p>
                  <p className="text-[11px] text-[#6c7a67]">{pick(language, STAGE_HI[c.stage] || c.stage, c.stage)}{c.expectedHarvest && <span className="inline-flex items-center gap-0.5 ml-1"><Calendar className="h-3 w-3" />{shortDate(c.expectedHarvest)}</span>}</p>
                </div>
                <span className="text-sm font-bold tabular-nums shrink-0" style={{ color: barColor(c.progress || 0) }}>{c.progress || 0}%</span>
              </div>
              <div className="h-2 rounded-full bg-black/5 mt-2 overflow-hidden">
                <motion.div className="h-full rounded-full" style={{ background: barColor(c.progress || 0) }} initial={{ width: 0 }} animate={{ width: `${c.progress || 0}%` }} transition={{ duration: 0.9, ease: "easeOut" }} />
              </div>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
}
